// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
import {Switch, Route} from 'react-router'
import GetAuthTokenTestingEndpoints from './components/getAuthToken/indexTesting'
import GetConnectionTokenTestingEndpoints from './components/getConnectionToken/indexTesting'
import CloseManageBusinessDayTestingEndpoints from './components/closeManageBusinessDay/indexTesting'
import GetPaymentTokenTestingEndpoints from './components/getPaymentToken/indexTesting'
import PaymentTerminalUnbindingTestingEndpoints from './components/paymentTerminalUnbinding/indexTesting'
import EndpointTestingList from './endpointTestingList'
    export default
        function EndpointTestingRoutes(
        props
        )
        {
            function mainRender() {
                return (
                    <Switch>
                        <Route path='/getAuthToken-test' component={GetAuthTokenTestingEndpoints} exact/>
                        <Route path='/getConnectionToken-test' component={GetConnectionTokenTestingEndpoints} exact/>
                        <Route path='/closeManageBusinessDay-test' component={CloseManageBusinessDayTestingEndpoints} exact/>
                        <Route path='/getPaymentToken-test' component={GetPaymentTokenTestingEndpoints} exact/>
                        <Route path='/paymentTerminalUnbinding-test' component={PaymentTerminalUnbindingTestingEndpoints} exact/>
                        <Route path='/endpoint-testing-list' component={EndpointTestingList} exact/>
                        <Route path='/' component={EndpointTestingList} exact/>
                    </Switch>
                )
            }
            return (
                mainRender()
            )
        }
